import {Injectable} from '@angular/core';
import {NgcCookieConsentService, NgcCookieConsentStatus} from 'ngx-cookieconsent';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CookieConsentService {
  constructor(private ccService: NgcCookieConsentService) {
  }

  getStatus(): NgcCookieConsentStatus {
    return this.ccService.getStatus();
  }

  hasConsented(): boolean {
    return this.ccService.hasConsented();
  }

  resetConsent(): void {
    this.ccService.destroy();
  }

  get statusChange$(): Observable<any> {
    return this.ccService.statusChange$;
  }
}
